import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  id: "scenario-scorecard",
  class: "row card rounded-0"
}
const _hoisted_3 = { class: "col-12 card-header" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-12 col-md-8" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "pb-0 mb-0" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "text-primary" }
const _hoisted_10 = { class: "col-sm-12 col-md-4 text-end" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 0,
  class: "card mb-4 shadow-sm w-100"
}
const _hoisted_17 = { class: "card-header bg-secondary text-white fw-bold" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "radio-custom" }
const _hoisted_22 = ["id", "name", "value", "onClick"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  class: "btn-group btn-group-toggle float-end mb-3",
  "data-toggle": "buttons"
}
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id", "name", "value"]
const _hoisted_27 = { key: 2 }
const _hoisted_28 = ["name", "onInput"]
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = {
  class: "btn-group btn-group-toggle float-end",
  "data-toggle": "buttons"
}
const _hoisted_35 = ["for"]
const _hoisted_36 = ["id", "name", "value"]
const _hoisted_37 = { class: "col-12 text-center" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "col-12 mt-4" }
const _hoisted_40 = {
  key: 2,
  class: "row"
}
const _hoisted_41 = {
  key: 0,
  class: "col-12"
}
const _hoisted_42 = { class: "col-12 mt-4" }
const _hoisted_43 = {
  key: 1,
  class: "col-12"
}
const _hoisted_44 = { class: "col-12 mt-4" }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { class: "col-12" }
const _hoisted_47 = {
  key: 0,
  class: "col-12"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  class: "col-12"
}
const _hoisted_50 = {
  key: 2,
  class: "col-12"
}
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  key: 3,
  class: "col-12"
}
const _hoisted_53 = { key: 0 }
const _hoisted_54 = {
  key: 4,
  class: "col-12"
}
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  key: 3,
  class: "alert alert-danger"
}
const _hoisted_57 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_alert = _resolveComponent("error-alert")!
  const _component_completed_form = _resolveComponent("completed-form")!
  const _component_tab = _resolveComponent("tab")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (typeof(_ctx.visit) !== 'undefined' && typeof(_ctx.view) !== 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row card text-white rounded-0 top-header" }, [
            _createElementVNode("div", { class: "col-12 text-center" }, [
              _createElementVNode("h2", { class: "my-3 fw-bold" }, "Visit Scorecard")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _ctx.visit.scenario.patient_image.location,
                    class: "rounded-circle float-start me-4",
                    width: "100"
                  }, null, 8, _hoisted_6),
                  _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.visit.scenario.patient_name), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.visit.scenario.title), 1),
                  _createElementVNode("p", _hoisted_9, "Visit was completed on " + _toDisplayString(_ctx.moment(_ctx.visit.utc_time || _ctx.visit.local_time).format('MM/DD/YY')) + " at " + _toDisplayString(_ctx.moment(_ctx.visit.utc_time || _ctx.visit.local_time).format('h:mma')), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.view === 'form' || _ctx.is_learner)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-lg btn-secondary-alt w-75 mb-2",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewRecording && _ctx.viewRecording(...args)))
                      }, "View Recording"))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-lg btn-secondary-alt w-75",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewScenario && _ctx.viewScenario(...args)))
                  }, "View Scenario")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.view === 'form')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: "col-12 px-5 py-4 text-center fw-bold",
                      innerHTML: _ctx.visit.scenario.scorecard.instructions
                    }, null, 8, _hoisted_13),
                    _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "w-75" }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question_set, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-12",
                        key: key
                      }, [
                        (question_set.name !== null)
                          ? (_openBlock(), _createElementBlock("h3", {
                              key: 0,
                              innerHTML: question_set.name,
                              class: "col-12 text-center"
                            }, null, 8, _hoisted_14))
                          : _createCommentVNode("", true),
                        (question_set.instructions !== null)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              innerHTML: question_set.instructions,
                              class: "col-12 px-5 pt-1 pb-4 text-center fw-bold"
                            }, null, 8, _hoisted_15))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(question_set.display_type == 1 ? 'row px-3' : 'card-columns px-3')
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question_set, (question, k) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(question_set.display_type == 1 ? 'col-12 col-md-6 col-lg-6' : ''),
                              key: k
                            }, [
                              (k !== 'instructions' && k !== 'name' && k !== 'display_type')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, "Question " + _toDisplayString(parseInt(k) + 1), 1),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("span", {
                                        innerHTML: question.question
                                      }, null, 8, _hoisted_19),
                                      _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
                                      (question.question_type_id == _ctx.QuestionType.MULTIPLECHOICE)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: answer.id
                                              }, [
                                                _createElementVNode("label", _hoisted_21, [
                                                  _createElementVNode("span", null, _toDisplayString(answer.answer), 1),
                                                  _createElementVNode("input", {
                                                    type: "radio",
                                                    id: answer.id,
                                                    name: question.id,
                                                    value: answer.id,
                                                    onClick: ($event: any) => (_ctx.clearError('error_'+question.id))
                                                  }, null, 8, _hoisted_22),
                                                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "checkmark" }, null, -1))
                                                ])
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (question.question_type_id == _ctx.QuestionType.TRUEFALSE)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                                                return (_openBlock(), _createElementBlock("label", {
                                                  key: answer.id,
                                                  class: _normalizeClass('p-3 btn btn-light btn_ques_' + question.id),
                                                  for: answer.id
                                                }, [
                                                  _createElementVNode("input", {
                                                    class: "btn-check",
                                                    type: "radio",
                                                    id: answer.id,
                                                    name: question.id,
                                                    value: answer.id,
                                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.buttonUpdate && _ctx.buttonUpdate(...args)))
                                                  }, null, 8, _hoisted_26),
                                                  _createTextVNode(_toDisplayString(answer.answer), 1)
                                                ], 10, _hoisted_25))
                                              }), 128))
                                            ]),
                                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clearfix" }, null, -1))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (question.question_type_id == _ctx.QuestionType.LONGFILL)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            _createElementVNode("textarea", {
                                              class: "w-100",
                                              name: question.id,
                                              onInput: ($event: any) => (_ctx.clearError('error_'+question.id))
                                            }, null, 40, _hoisted_28)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (question.question_type_id == _ctx.QuestionType.LIKERT)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                            _createElementVNode("div", _hoisted_30, [
                                              _createElementVNode("div", _hoisted_31, [
                                                _createElementVNode("small", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, index) => {
                                                    return (_openBlock(), _createElementBlock("span", {
                                                      key: answer.id
                                                    }, [
                                                      _createTextVNode(_toDisplayString(index + 1) + " = " + _toDisplayString(answer.answer), 1),
                                                      (index !== 4)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, ", "))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  }), 128))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_33, [
                                                _createElementVNode("div", _hoisted_34, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, index) => {
                                                    return (_openBlock(), _createElementBlock("label", {
                                                      key: answer.id,
                                                      class: _normalizeClass('p-3 btn btn-light btn_ques_' + question.id),
                                                      for: 'ans_' + answer.id
                                                    }, [
                                                      _createElementVNode("input", {
                                                        class: "btn-check",
                                                        type: "radio",
                                                        id: 'ans_' + answer.id,
                                                        name: question.id,
                                                        value: answer.id,
                                                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.buttonUpdate && _ctx.buttonUpdate(...args)))
                                                      }, null, 8, _hoisted_36),
                                                      _createTextVNode(_toDisplayString(index + 1), 1)
                                                    ], 10, _hoisted_35))
                                                  }), 128))
                                                ])
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_error_alert, {
                                        elm_id: 'error_'+question.id
                                      }, null, 8, ["elm_id"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 2),
                        _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("button", {
                        class: "btn btn-lg btn-primary my-4 px-5 fw-bold",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitScorecard && _ctx.submitScorecard(...args)))
                      }, "SUBMIT SCORECARD")
                    ])
                  ]))
                : (_ctx.view === 'observer_complete')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_completed_form, {
                          form: _ctx.visit.scenario.scorecard,
                          visit_form: _ctx.visit.observer_scorecards.filter(scorecard => scorecard.scorer_user_id === _ctx.user.props.id)[0]
                        }, null, 8, ["form", "visit_form"])
                      ])
                    ]))
                  : (_ctx.view === 'learner_complete')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        (_ctx.visit.scenario.scorecard_display_type_id === _ctx.ScorecardDisplayType.FEEDBACK)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createVNode(_component_completed_form, {
                                  form: _ctx.visit.scenario.feedback_form,
                                  visit_form: _ctx.visit.feedback_form
                                }, null, 8, ["form", "visit_form"])
                              ])
                            ]))
                          : (_ctx.visit.scenario.scorecard_display_type_id === _ctx.ScorecardDisplayType.MERGED)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createVNode(_component_completed_form, {
                                    form: _ctx.visit.scenario.scorecard,
                                    visit_form: _ctx.visit.learner_scorecard
                                  }, null, 8, ["form", "visit_form"])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _createVNode(_component_tabs, {
                                    options: { useUrlFragment: false },
                                    "nav-class": "nav nav-pills m-3",
                                    "nav-item-class": "nav-item",
                                    "nav-item-link-class": "nav-link",
                                    "nav-item-link-active-class": "active"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.visit.scenario.scorecard_display_type_id === _ctx.ScorecardDisplayType.FEEDBACK_INDIVIDUAL)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                            _createVNode(_component_tab, {
                                              name: "SP Scorecard",
                                              active: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_completed_form, {
                                                  form: _ctx.visit.scenario.feedback_form,
                                                  visit_form: _ctx.visit.feedback_form
                                                }, null, 8, ["form", "visit_form"])
                                              ]),
                                              _: 1
                                            }),
                                            (_ctx.visit.is_scorecard_complete)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visit.observer_scorecards, (scorecard, index) => {
                                                    return (_openBlock(), _createBlock(_component_tab, {
                                                      key: scorecard.id,
                                                      name: 'Scorecard ' + (index + 1)
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_completed_form, {
                                                          form: _ctx.visit.scenario.scorecard,
                                                          visit_form: scorecard
                                                        }, null, 8, ["form", "visit_form"])
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["name"]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : (_ctx.visit.scenario.scorecard_display_type_id === _ctx.ScorecardDisplayType.FEEDBACK_MERGED)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                              _createVNode(_component_tab, {
                                                name: "SP Scorecard",
                                                active: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_completed_form, {
                                                    form: _ctx.visit.scenario.feedback_form,
                                                    visit_form: _ctx.visit.feedback_form
                                                  }, null, 8, ["form", "visit_form"])
                                                ]),
                                                _: 1
                                              }),
                                              (_ctx.visit.is_scorecard_complete)
                                                ? (_openBlock(), _createBlock(_component_tab, {
                                                    key: 0,
                                                    name: "Merged"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_completed_form, {
                                                        form: _ctx.visit.scenario.scorecard,
                                                        visit_form: _ctx.visit.learner_scorecard
                                                      }, null, 8, ["form", "visit_form"])
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (_ctx.visit.scenario.scorecard_display_type_id === _ctx.ScorecardDisplayType.FEEDBACK_INDIVIDUAL_MERGED)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                _createVNode(_component_tab, {
                                                  name: "SP Scorecard",
                                                  active: ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_completed_form, {
                                                      form: _ctx.visit.scenario.feedback_form,
                                                      visit_form: _ctx.visit.feedback_form
                                                    }, null, 8, ["form", "visit_form"])
                                                  ]),
                                                  _: 1
                                                }),
                                                (_ctx.visit.is_scorecard_complete)
                                                  ? (_openBlock(), _createBlock(_component_tab, {
                                                      key: 0,
                                                      name: "Merged"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_completed_form, {
                                                          form: _ctx.visit.scenario.scorecard,
                                                          visit_form: _ctx.visit.learner_scorecard
                                                        }, null, 8, ["form", "visit_form"])
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                                (_ctx.visit.is_scorecard_complete)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visit.observer_scorecards, (scorecard, index) => {
                                                        return (_openBlock(), _createBlock(_component_tab, {
                                                          key: scorecard.id,
                                                          name: 'Observer Scorecard ' + (index + 1)
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_completed_form, {
                                                              form: _ctx.visit.scenario.scorecard,
                                                              visit_form: scorecard
                                                            }, null, 8, ["form", "visit_form"])
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["name"]))
                                                      }), 128))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (_ctx.visit.scenario.scorecard_display_type_id === _ctx.ScorecardDisplayType.INDIVIDUAL)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                  (_ctx.visit.is_scorecard_complete)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visit.observer_scorecards, (scorecard, index) => {
                                                          return (_openBlock(), _createBlock(_component_tab, {
                                                            key: scorecard.id,
                                                            name: 'Observer Scorecard ' + (index + 1),
                                                            active: index===0
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_completed_form, {
                                                                form: _ctx.visit.scenario.scorecard,
                                                                visit_form: scorecard
                                                              }, null, 8, ["form", "visit_form"])
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["name", "active"]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : (_ctx.visit.scenario.scorecard_display_type_id === _ctx.ScorecardDisplayType.INDIVIDUAL_MERGED)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                    (_ctx.visit.is_scorecard_complete)
                                                      ? (_openBlock(), _createBlock(_component_tab, {
                                                          key: 0,
                                                          name: "Merged",
                                                          active: ""
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_completed_form, {
                                                              form: _ctx.visit.scenario.scorecard,
                                                              visit_form: _ctx.visit.learner_scorecard
                                                            }, null, 8, ["form", "visit_form"])
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.visit.is_scorecard_complete)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visit.observer_scorecards, (scorecard, index) => {
                                                            return (_openBlock(), _createBlock(_component_tab, {
                                                              key: scorecard.id,
                                                              name: 'Observer Scorecard ' + (index + 1)
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_completed_form, {
                                                                  form: _ctx.visit.scenario.scorecard,
                                                                  visit_form: scorecard
                                                                }, null, 8, ["form", "visit_form"])
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["name"]))
                                                          }), 128))
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_56, " Error Loading Scorecard "))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && typeof(_ctx.visit) === 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _cache[11] || (_cache[11] = _createElementVNode("p", null, "Error Loading Scorecard", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.loadErrorMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}